import { type SessionSummary } from '../../services/api/sessions';

export type QualityFilter = 'all' | 'good' | 'degraded' | 'poor' | 'insufficient' | 'unanalyzed';

export type QualityCounts = {
  good: number;
  degraded: number;
  poor: number;
  insufficient: number;
  unanalyzed: number;
};

export const countQuality = (sessions: SessionSummary[]): QualityCounts => {
  const counts: QualityCounts = { good: 0, degraded: 0, poor: 0, insufficient: 0, unanalyzed: 0 };

  for (const session of sessions) {
    if (session.analysisQuality === null) counts.unanalyzed += 1;
    else counts[session.analysisQuality] += 1;
  }

  return counts;
};

export const filterSessions = (
  sessions: SessionSummary[],
  { search, quality }: { search: string; quality: QualityFilter },
): SessionSummary[] => {
  const needle = search.toLowerCase();

  return sessions.filter((session) => {
    if (!session.sessionId.toLowerCase().includes(needle)) return false;
    if (quality === 'all') return true;
    if (quality === 'unanalyzed') return session.analysisQuality === null;
    return session.analysisQuality === quality;
  });
};

// Batchen hoppar över sessioner utan kundturer — de går inte att bedöma. Därför
// är den här siffran lägre än pillret "Inte analyserade", som räknar alla.
export const countBatchCandidates = (sessions: SessionSummary[]): number =>
  sessions.filter((session) => session.analysisQuality === null && session.requestCount >= 1)
    .length;
